import React from 'react';
import { Logo } from './Logo';
import { site } from '../data/siteData';

const sections = [
  { id: 'services', label: 'Services' },
  { id: 'contact', label: 'Contact' },
  { id: 'about', label: 'About' },
];

function useActiveSection() {
  const [active, setActive] = React.useState('about');

  React.useEffect(() => {
    const ids = sections.map(s => s.id);
    const els = ids
      .map(id => document.getElementById(id))
      .filter(Boolean);

    if (!els.length) return;

    const obs = new IntersectionObserver(
      entries => {
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => (b.intersectionRatio || 0) - (a.intersectionRatio || 0))[0];
        if (visible?.target?.id) setActive(visible.target.id);
      },
      {
        root: null,
        rootMargin: '-30% 0px -60% 0px',
        threshold: [0.05, 0.1, 0.2, 0.3, 0.4],
      }
    );

    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return active;
}

export function Navbar() {
  const active = useActiveSection();

  return (
    <header className="nav">
      <div className="container navInner">
        <a href="#top" className="brand" aria-label="Go to top" style={{ padding: 0 }}>
          <Logo size={38} />
          <div className="brandText">
            <div className="brandName">{site.brand.name}</div>
            <div className="brandTag">{site.brand.tagline || 'Expert Software Solutions'}</div>
          </div>
        </a>

        <nav className="navLinks" aria-label="Primary">
          {sections.map(s => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className={active === s.id ? 'navLink active' : 'navLink'}
              data-active={active === s.id}
            >
              {s.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
